import { Component, OnInit } from "@angular/core";
import { Auth0User } from "app/_core/services/models/auth0-user.model";
import { DealerService } from "../../../dealer/dealer.service";
import { Router } from "@angular/router";
import { KioskService } from "app/kiosk/kiosk.service";
import { Auth0Service } from "app/_core/services/auth0.service";

@Component({
    selector: "dealer-display",
    templateUrl: "./dealer-display.component.html",
    styleUrls: ["./dealer-display.component.scss"],
    standalone: false
})
export class DealerDisplayComponent implements OnInit {
	_dealer: Auth0User;
	_kiosk: Auth0User;
	_dontShow = false;

	constructor(
		private __dealerService: DealerService,
		private __kioskService: KioskService,
		private __auth0Service: Auth0Service,
		private __router: Router
	) {}

	ngOnInit() {
		const prohibitedUrls = ["kiosk", "dealer"];
		if (prohibitedUrls.some(url => this.__router.url.includes(url))) {
			this._dontShow = true;
		} else {
			this._dontShow = false;
		}
		this._dealer = this.__dealerService.getDealer();
		this._kiosk = this.__kioskService.getKiosk();
	}

	_logoutDealer() {
		this.__auth0Service.logoutDealer();
	}

	_logoutKiosk() {
		this.__auth0Service.logoutKiosk();
	}
}
